import { render, staticRenderFns } from "./editor.component.vue?vue&type=template&id=ff90ac5e&scoped=true"
import script from "./editor.component.vue?vue&type=script&lang=js"
export * from "./editor.component.vue?vue&type=script&lang=js"
import style0 from "./editor.component.vue?vue&type=style&index=0&id=ff90ac5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff90ac5e",
  null
  
)

export default component.exports